module.exports = __webpack_public_path__ + "static/media/promo3.22180f03.jpg";